exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".phone-input-wrapper{position:relative;clear:both}.phone-input-wrapper .input-edit-able{font-size:13px;padding:1px 0;border-radius:4px;position:absolute;top:43px;z-index:10}.phone-input-wrapper .input-edit-able .fa{width:25px}.phone-input-wrapper .top{top:-26px}.phone-input-wrapper .input-edit-able-save{right:1px}.phone-input-wrapper .input-edit-able-cancel{right:34px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PhoneNumberInput/style.scss
// module id = 1774
// module chunks = 32